import { useState } from "react";
import { Phone, X } from "lucide-react";
import { COMPANY } from "../../data/site";

export default function MobileCTA() {
    const [open, setOpen] = useState(false);
    return (
        <div className="md:hidden fixed bottom-5 right-5 z-50" data-testid="mobile-cta-wrapper">
            {open && (
                <div className="mb-3 bg-[#0E1721] border border-brand-accent/30 shadow-2xl p-3 flex flex-col gap-2 min-w-[220px]">
                    {COMPANY.phones.map((p) => (
                        <a
                            key={p.tel}
                            href={`tel:${p.tel}`}
                            data-testid={`mobile-cta-call-${p.label.toLowerCase()}`}
                            className="flex items-center gap-3 px-3 py-2 text-sm text-white hover:bg-brand-accent/10"
                        >
                            <Phone className="w-4 h-4 text-brand-accent" />
                            <span><span className="text-white/40 text-xs mr-2">{p.label}</span>{p.value}</span>
                        </a>
                    ))}
                </div>
            )}
            <button
                onClick={() => setOpen((s) => !s)}
                data-testid="mobile-cta-toggle"
                className="bg-brand-primary hover:bg-brand-primaryHover text-white w-14 h-14 rounded-full flex items-center justify-center shadow-[0_0_30px_rgba(0,194,199,0.45)] transition-all"
                aria-label="Appeler"
            >
                {open ? <X className="w-6 h-6" /> : <Phone className="w-6 h-6" />}
            </button>
        </div>
    );
}
